/**
 * @generated SignedSource<<6df3010c8e2aa9809c959d6e8c3de28e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TestCustomMcpServerUrlInput = {
  authType: string;
  credentials?: string | null | undefined;
  url: string;
};
export type McpServersOnboardingContentTestUrlMutation$variables = {
  input: TestCustomMcpServerUrlInput;
};
export type McpServersOnboardingContentTestUrlMutation$data = {
  readonly testCustomMcpServerUrl: {
    readonly error: string | null | undefined;
    readonly success: boolean;
    readonly tools: ReadonlyArray<string>;
  };
};
export type McpServersOnboardingContentTestUrlMutation = {
  response: McpServersOnboardingContentTestUrlMutation$data;
  variables: McpServersOnboardingContentTestUrlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TestConnectionPayload",
    "kind": "LinkedField",
    "name": "testCustomMcpServerUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tools",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "McpServersOnboardingContentTestUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "McpServersOnboardingContentTestUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e0627939e2133ccf9fe9ced4313d6d43",
    "id": null,
    "metadata": {},
    "name": "McpServersOnboardingContentTestUrlMutation",
    "operationKind": "mutation",
    "text": "mutation McpServersOnboardingContentTestUrlMutation(\n  $input: TestCustomMcpServerUrlInput!\n) {\n  testCustomMcpServerUrl(input: $input) {\n    success\n    tools\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "17c135c1f46167561a42ac0bcc06fe67";

export default node;
